export const SET_MESSAGE_CONFIRMACAOEMAIL_ALTERACAO = "SET_MESSAGE_CONFIRMACAOEMAIL_ALTERACAO";
export const SET_LOADING_VALUE_ALTERACAO_EMAIL = "SET_LOADING_VALUE_ALTERACAO_EMAIL";
// export const SET_ERROR_VALUE = "SET_ERROR_VALUE";